import { Box, FlexGrid, Select } from '@telus-uds/components-web'
import { useState } from 'react'
import { BlockRenderer } from 'src/siteBuilder/renderer/contentful/BlockRenderer'

import type {
  TypeDropdownContentFilterWithoutUnresolvableLinksResponse,
  TypeDropdownContentFilterItemWithoutUnresolvableLinksResponse,
} from '@/contentful-types'

const getSelectOptions = (
  dropdownContentFilterItems: TypeDropdownContentFilterItemWithoutUnresolvableLinksResponse[]
): { id: string; label: string }[] =>
  dropdownContentFilterItems.map((option) => ({ label: option?.fields?.label, id: option?.fields?.id }))

const filterContentByDropdownId = (
  dropdownContentFilterItems: TypeDropdownContentFilterItemWithoutUnresolvableLinksResponse[],
  selectedDropdownId
) =>
  dropdownContentFilterItems.reduce((acc, curr) => {
    if (curr?.fields?.id === selectedDropdownId) {
      acc.push(curr?.fields)
    }
    return acc
  }, [])

// DropdownContentFilter takes in an array of dropdownContentFilterItems and renders a dropdown with the labels of each item
// Content rendered below the dropdown is determined by the selected dropdown item
const DropdownContentFilter = ({
  allOptionsLabel,
  preselectedId,
  dropdownContentFilterItems = [],
  selectPlaceholder,
  spaceBelowDropdown,
  selectLabel,
  xs,
  sm,
  md,
  lg,
  xl,
}: TypeDropdownContentFilterWithoutUnresolvableLinksResponse['fields']) => {
  const [selectedDropdownId, setSelectedDropdown] = useState<string | null>(preselectedId || null)

  const selectOptions = getSelectOptions(dropdownContentFilterItems)

  const contentToRender =
    selectedDropdownId && selectedDropdownId !== 'allOptions'
      ? filterContentByDropdownId(dropdownContentFilterItems, selectedDropdownId)
      : dropdownContentFilterItems.map((item) => item.fields)

  return (
    <div data-testid="DropdownContentFilter">
      <FlexGrid>
        <FlexGrid.Row>
          <FlexGrid.Col xs={xs} sm={sm} md={md} lg={lg} xl={xl} testID="select-col">
            <Box bottom={spaceBelowDropdown} testID="dropdown-container">
              <Select
                onChange={(param: string) => {
                  setSelectedDropdown(param)
                }}
                value={selectedDropdownId}
                placeholder={selectPlaceholder}
                label={selectLabel}
              >
                {allOptionsLabel && <Select.Item value="allOptions">{allOptionsLabel}</Select.Item>}
                {selectOptions.length > 0 &&
                  selectOptions.map((option, key) => (
                    <Select.Item key={key} value={option.id}>
                      {option.label}
                    </Select.Item>
                  ))}
              </Select>
            </Box>
          </FlexGrid.Col>
        </FlexGrid.Row>
      </FlexGrid>
      {contentToRender.length &&
        contentToRender.map((item: TypeDropdownContentFilterItemWithoutUnresolvableLinksResponse['fields'], key) => (
          <BlockRenderer key={key} data-testid={`DropdownContentFilterItem-content-${item.id}`} block={item.content} />
        ))}
    </div>
  )
}

export default DropdownContentFilter
